const ja = {
  nav: {
    home: 'ホーム',
    sell: '出品',
    wanted: '募集',
    favorites: 'お気に入り',
    chat: 'チャット',
    orders: '注文履歴',
    login: 'ログイン / 登録',
    logout: 'ログアウト',
    profile: 'プロフィール',
    dogWalking: 'お散歩代行',
    adoption: '里親募集',
  },
  hero: {
    title: 'ペット用品マーケット',
    subtitle: 'ペットにも地球にも優しい選択を',
    searchPlaceholder: 'ペット用品を検索...',
  },
  product: {
    price: '価格',
    condition: '商品状態',
    location: '場所',
    contactSeller: '出品者に連絡',
    addFavorite: 'お気に入りに追加',
  },
  auth: {
    login: 'ログイン',
    register: '登録',
    email: 'メールアドレス',
    password: 'パスワード',
    name: '名前',
  },
  common: {
    loading: '読み込み中...',
    noResults: '結果が見つかりません',
    viewAll: 'すべて見る',
    back: '戻る',
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    confirm: '確認',
  },
};

export default ja;
